import styled from "styled-components";

export const FooterButtons = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-flow: row wrap;
  gap: 1em;

  button {
    width: max-content;
    flex: 1 1 auto;
  }
`;

export const ColdChainText = styled.p`
  margin: 0;
  color: var(--accent);
  display: flex;
  flex-flow: row nowrap;
  gap: 0.5em;
  align-items: center;
  font-weight: 600;

  svg {
    font-size: x-large;
  }
`;
